
    import { mapActions, mapGetters } from "vuex"
    import { defineComponent, PropType } from "vue"
    import InputTextarea from "./misc/InputTextarea.vue"
    import gptAPI from "@/api/gpt"
    import ls from "local-storage"
    import KeyWarning from "@/components/misc/KeyWarning.vue"
    import RunButton from "@/components/misc/RunButton.vue"
    import { VarValues } from "@/store/modules/prompts"
import { CreateCompletionRequest } from "openai"

    export async function gptQueryBase(handler: () => Promise<string | undefined>, context: {[key: string]: any}): Promise<string | undefined> {
        if (!context.isLoading) {
            context.isLoading = true
            const handlers = {
                code: "getCodeFirst",
                image: "getImage",
            } as {[key: string]: string}
            try {
                const res = await handler()
                return res || ""
            } catch (e) {
                console.error("App error: " + e)
            } finally {
                context.isLoading = false
            }
        }
    }
    export async function gptQuery(prompt: string, context: {[key: string]: any}, settings?: Partial<CreateCompletionRequest>): Promise<string | undefined> {
        const opts = {
            max_tokens: 2000,
            ...((ls as any)("gptSettings") || {}),
            ...(settings || {}),
        }
        return gptQueryBase(async () => gptAPI.getFirst(prompt, opts), context)
    }
    export async function gptQueryRun(prompt: string, context: {[key: string]: any}): Promise<string | undefined> {
        // !context.user && context.guest?.guestId === null && await context.getUser()
        const res = await gptQueryBase(async () => context.runPlayground(prompt) || "", context);
        await context.getUser()
        return res
    }
    export async function gptQueryRunPrompt(promptId: string, varValues: VarValues[], context: {[key: string]: any}, settings?: Partial<CreateCompletionRequest>): Promise<string | undefined> {
        // !context.user && context.guest?.guestId === null && await context.getUser()
        const res = await gptQueryBase(async () => context.runPrompt({ promptId, varValues, settings }) || "", context);
        await context.getUser()
        return res
    }

    export default defineComponent({
        props: {

        },
        components: {
            RunButton,
            InputTextarea,

        },
        // emits: ['update:modelValue'], this.$emit('update:modelValue', title)
        data() {
            return {
                showKeyDescription: false,
                result: "",
                isLoading: false,
                prompt: "",
            }
        },
        computed: {
            ...mapGetters(["isAdmin", "isModer", "user", "guest"]),

        },
        methods: {
            ...mapActions(["runPlayground", "getUser"]),
            async run() {
                if ((ls as any)("mode") !== "client") {
                    this.result = (await gptQueryRun(this.prompt, this))?.trim() || ""
                } else {
                    if ((ls as any)("apiKey")) {
                        this.result = (await gptQuery(this.prompt, this))?.trim() || ""
                        this.showKeyDescription = false
                    } else {
                        this.showKeyDescription = true
                    }
                }
            },
        },
    })

    